/* Copyright 2013-2018 The MathWorks, Inc. */

define([
    "dojo/_base/declare",
    "dojo/_base/lang",
    "MW/uiframework/UIBuilderFactory",
    "MW/uiframework/contextmanager/FeatureManager"
], function (declare, lang, UIBuilderFactory, FeatureManager) {
    return declare([FeatureManager], {

        constructor: function (args) {
            this._qabContextualControlsActionMap = args.qabContextualControlsActionMap;
            this._registeredQuickAccessActions = {};
        },

        registerQuickAccessAction: function (args) {
            if (!this._registeredQuickAccessActions[args.appId]) {
                this._registeredQuickAccessActions[args.appId] = {};
            }

            if (!this._registeredQuickAccessActions[args.appId][args.contextId]) {
                this._registeredQuickAccessActions[args.appId][args.contextId] = {};
            }

            if (args.quickAccessControlTag && args.actionId) {
                this._registeredQuickAccessActions[args.appId][args.contextId][args.quickAccessControlTag] = args.actionId;
            }
        },

        unregisterQuickAccessAction: function (args) {
            if (this._registeredQuickAccessActions[args.appId]) {
                if (this._registeredQuickAccessActions[args.appId][args.contextId]) {
                    if (this._registeredQuickAccessActions[args.appId][args.contextId][args.quickAccessControlTag]) {
                        delete this._registeredQuickAccessActions[args.appId][args.contextId][args.quickAccessControlTag];
                    } else {
                        delete this._registeredQuickAccessActions[args.appId][args.contextId];
                    }
                }
            }
        },

        _update: function (context, secondaryContext) {

            // Reset all actions to the placeholder actions
            Object.keys(this._qabContextualControlsActionMap).forEach(function (controlTag) {
                var controlId = this._uiBuilder.tagToId(controlTag);
                if (this._uiBuilder.exists(controlId)) {
                    this._uiBuilder.set(controlId, "actionId", this._qabContextualControlsActionMap[controlTag]);
                }
            }, this);


            // Apply the quickAccess actions registered for the global context of the parent app
            if (context && this._contextManagerImpl.parentAppId) {
                this._applyQuickAccessActions(this._contextManagerImpl.parentAppId, "global");
            }

            if (context && this._registeredQuickAccessActions[context.appId]) {

                // Apply the global quick access actions of the App that came into context(except when it is the parent app, since its quick access actions have already been applied above)
                if (context.appId !== this._contextManagerImpl.parentAppId) {
                    this._applyQuickAccessActions(context.appId, "global");
                }

                // Apply the quick access actions of all the contextIds in the contextIdList
                if (context.contextIdList) {
                    context.contextIdList.forEach(function (contextId) {
                        if (contextId !== "global") {
                            this._applyQuickAccessActions(context.appId, contextId);
                        }
                    }, this);
                }
            }

            if (secondaryContext && secondaryContext.contextIdList && this._registeredQuickAccessActions[secondaryContext.appId]) {
                secondaryContext.contextIdList.forEach(function (contextId) {
                        this._applyQuickAccessActions(secondaryContext.appId, contextId);
                }, this);
            }
        },

        _applyQuickAccessActions: function (appId, contextId) {
            if (this._registeredQuickAccessActions[appId] && this._registeredQuickAccessActions[appId][contextId]) {
                Object.keys(this._registeredQuickAccessActions[appId][contextId]).forEach(function (controlTag) {
                    var controlId = this._uiBuilder.tagToId(controlTag);
                    if (this._uiBuilder.exists(controlId)) {
                        this._uiBuilder.set(controlId, "actionId", this._registeredQuickAccessActions[appId][contextId][controlTag]);
                    }
                }, this);
            }
        }
    });
});